<template>
  <v-autocomplete
    no-data-text="Danh sách trống"
    v-bind="this.$attrs"
    return-object
    item-text="name"
    item-value="id"
    :items="staffs"
    @change="onChange"
    v-on:input="$emit('input', $event)"
    @update:search-input="update"
    clearable
    :loading="loading"
  ></v-autocomplete>
</template>

<script>
// import { mapGetters } from 'vuex'
import { Staff } from '@/plugins/api'

export default {
  data: () => ({
    loading: false,
    staffs: [],
    role: ''
  }),
  props: {
    filters: Object,
    defaultStaffs: Array,
    options: Object
  },
  computed: {
    // ...mapGetters('auth', ['ownStaffIds'])
  },
  async created() {
    if (this.defaultStaffs) {
      this.staffs = this.defaultStaffs
    }
    await this.fetchAllStaffs()
  },
  methods: {
    async fetchAllStaffs(query) {
      this.loading = true
      const params = {
        ...this.filters,
        ...query,
        'role.type': 'driver',
        _sort: 'name:ASC',
        _limit: -1
      }
      if (this.ownStaffIds) params['id_in'] = this.ownStaffIds
      this.staffs = await Staff.fetch(params)
      this.loading = false
    },
    async update(data) {},
    onChange(data) {
      this.$emit('change', data)
    }
  },
  watch: {
    filters(newVale) {
      if (newVale) this.fetchAllStaffs(newVale)
    }
  }
}
</script>
